import { Box, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';

const PREFIX = 'CellDetail';

const classes = {
  container: `${PREFIX}-container`,
};

const StyledCellDetail = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    height: '100%',
    paddingLeft: '8px',
  },
}));

type CellDetailProps = {
  tooltipText?: string;
  children: React.ReactNode;
};

const CellDetail = ({ tooltipText, children }: CellDetailProps) => {
  const content = (
    <StyledCellDetail className={classes.container}>
      {children}
    </StyledCellDetail>
  );

  return tooltipText ? (
    <Tooltip title={tooltipText}>{content}</Tooltip>
  ) : (
    content
  );
};

export { CellDetail };
export type { CellDetailProps };
